export function ec_apply_cart(cart) {
  //for each cart attributes
  Object.entries(cart).forEach(([key, value]) => {
    document.querySelectorAll('[data-cart-' + key + ']').forEach((el) => {
      // if data-type == integer and value is number, convert to integer
      if (el.dataset.type === 'integer' && typeof value === 'number') {
        // eslint-disable-next-line no-const-assign
        value = parseInt(value)
      }
      // if el is input, set value, or innerHTML
      if (el.tagName.toLowerCase() === 'input') {
        el.value = value
      } else {
        el.innerHTML = value
      }
    })
  })
  document.dispatchEvent(
    new CustomEvent('odims:cart:applied', {
      detail: cart,
    })
  )
}
